import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import CountrySelect from '../common/contact/countryselector.component.jsx'
import StateSelect from '../common/contact/stateselector.component.jsx'
import GlobalHelper from "../common/GlobalHelper.jsx";
import AddressFormFields from "./components/AddressFormFieldsComponent";
import EmailInput from '../common/inputs/EmailInputComponent.tsx'
import PhoneNumberInput from '../common/inputs/PhoneNumberInputComponent.tsx'

const messages = defineMessages({
    "company_name_placeholder": {
        id: 'company.modal.placeholder.company_name',
        defaultMessage: 'XYZ Inc.',
    },
    "email_placeholder": {
        id: 'customer.modal.placeholder.email',
        defaultMessage: 'Enter email',
    },
    "primary_phone_number_placeholder": {
        id: 'customer.modal.placeholder.primary_phone_number',
        defaultMessage: 'Enter primary phone number',
    },
    "mobile_phone_number_placeholder": {
        id: 'customer.modal.placeholder.mobile_phone_number',
        defaultMessage: 'Enter mobile phone number',
    },
    "language_dropdown_fr": {
        id: 'customer.drowpdown.language.fr',
        defaultMessage: 'French',
    },
    "language_dropdown_en": {
        id: 'customer.drowpdown.language.en',
        defaultMessage: 'English',
    }
})

class CompanyInputs extends Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            advancedForm: this.props.advancedForm || false, //by default, we show the short version of the form
            labelInline: this.props.labelInline || false, //by default, we show the short version of the form
            companyName: '',
            companyEmail: '',
            companyPrimaryPhoneNumber: '',
            companyPrimaryPhoneNumberExtension: '',
            companyPhoneNumberMobile: '',
            companyDeletedAt: '',
            contact: null,
            onChange: this.props.onChange || function () {
            },
            changeFormIsValid: this.props.changeFormIsValid || function () {
            },
            address: {
                addressId: '',
                street: '',
                street2: '',
                city: '',
                postalCode: '',
                state: '',
                stateCode: '',
                country: '',
                countryCode: '',
            },
        }
        this.handleFormChange = this.handleFormChange.bind(this)
        this.handleAddressChange = this.handleAddressChange.bind(this)
        this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this)
    }

    componentDidMount() {
        if (this.props.contact) {
            this.setCompany(this.props.contact)
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.contact) {
            this.setCompany(nextProps.contact)
        }
        this.setState({
            advancedForm: nextProps.advancedForm || false
        })
    }

    setCompany(contact) {
        if (this.state.contact && this.state.contact.id === contact.id) {
            return
        }
        let companyPrimaryPhoneNumber = ''
        let companyPrimaryPhoneNumberExtension = ''
        let companyMobilePhoneNumber = ''
        for (let i = 0; i < contact.attributes.phoneNumbers.length; i++) {
            if (contact.attributes.phoneNumbers[i]["type"] === "primary") {
                companyPrimaryPhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
                companyPrimaryPhoneNumberExtension = contact.attributes.phoneNumbers[i]["extension"]
            }
            if (contact.attributes.phoneNumbers[i]["type"] === "mobile") {
                companyMobilePhoneNumber = contact.attributes.phoneNumbers[i]["phoneNumber"]
            }
        }

        const billingAddress = contact.attributes.address || {}
        this.state.changeFormIsValid(GlobalHelper.isValidPhoneNumberInput(companyPrimaryPhoneNumber))
        this.setState({
            contact: contact,
            companyName: contact.attributes.name,
            companyEmail: contact.attributes.email,
            companyPrimaryPhoneNumber: companyPrimaryPhoneNumber,
            companyPrimaryPhoneNumberExtension: companyPrimaryPhoneNumberExtension,
            companyPhoneNumberMobile: companyMobilePhoneNumber,
            companyDeletedAt: contact.attributes.deletedAt,
            address: {
                ...this.state.address,
                addressId: billingAddress.addressId,
                street: billingAddress.street,
                street2: billingAddress.street2,
                city: billingAddress.city,
                postalCode: billingAddress.postalCode,
                state: billingAddress.state,
                stateCode: billingAddress.stateCode,
                country: billingAddress.country,
                countryCode: billingAddress.countryCode,
            },
        })
    }


    handleAddressChange(change) {
        this.setState({
            address: {
                ...this.state.address,
                ...change,
            },
        }, this.didChanged)
    }

    handlePhoneNumberChange(phoneNumber, isValidPhoneNumber) {
        this.state.changeFormIsValid(isValidPhoneNumber)
        this.setState({
            companyPrimaryPhoneNumber: phoneNumber,
        }, () => {
            this.didChanged()
        })
    }

    handleFormChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        }, this.didChanged)
    }

    didChanged() {
        const payloadPhoneNumbers = []
        if (this.state.companyPrimaryPhoneNumber) {
            payloadPhoneNumbers.push({
                type: "primary",
                phoneNumber: this.state.companyPrimaryPhoneNumber,
                extension: this.state.companyPrimaryPhoneNumberExtension

            })
        }
        if (this.state.companyPhoneNumberMobile) {
            payloadPhoneNumbers.push({
                type: "mobile",
                phoneNumber: this.state.companyPhoneNumberMobile,
                extension: "",
            })
        }
        this.state.onChange({
            name: this.state.companyName,
            email: this.state.companyEmail.trim(),
            phoneNumbers: payloadPhoneNumbers,
            address: {
                ...this.state.address,
                isDefault: true,
                addressType: 'billing',
            }
        })
    }

    render() {
        return (
            <>
                <div className='d-flex'>
                    <div className='flex-fill p-2'>
                        <label htmlFor="companyName" className="form-label">
                            <FormattedMessage
                                id="customer.modal.add_form.company_name_label"
                                defaultMessage="Company Name"
                            />
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="companyName"
                            name="companyName"
                            value={this.state.companyName}
                            placeholder={this.props.intl.formatMessage(messages["company_name_placeholder"])}
                            onChange={this.handleFormChange}
                            required />
                        <div className="invalid-feedback">
                            <FormattedMessage
                                id="customer.modal.add_form.company_name_field_error"
                                defaultMessage="Please ensure the company name is filled out properly"
                            />
                        </div>
                    </div>
                </div>

                <div className='d-flex'>
                    <div className='flex-fill p-2'>
                        <label htmlFor="email" className="form-label">
                            <FormattedMessage
                                id="customer.modal.add_form.email_label"
                                defaultMessage="Email"
                            />
                        </label>

                        <EmailInput
                            required={false}
                            type="text"
                            className="form-control"
                            id="email"
                            name="companyEmail"
                            email={this.state.companyEmail}
                            placeholder={this.props.intl.formatMessage(messages["email_placeholder"])}
                            handleFormChange={this.handleFormChange}
                        />
                        <div className="invalid-feedback">
                            <FormattedMessage
                                id="customer.modal.add_form.email_field_error"
                                defaultMessage="Please ensure the email is filled out properly"
                            />
                        </div>
                    </div>
                </div>

                <div className='d-flex'>
                    <div className='flex-fill p-2'>
                        <label htmlFor="primaryPhoneNumber" className="form-label">
                            <FormattedMessage
                                id="customer.modal.add_form.primary_phone_number_label"
                                defaultMessage="Phone Number (Primary)"
                            />
                        </label>
                        <PhoneNumberInput
                            className="form-control"
                            id="primaryPhoneNumber"
                            name="companyPrimaryPhoneNumber"
                            phoneNumber={this.state.companyPrimaryPhoneNumber}
                            placeholder={this.props.intl.formatMessage(messages["primary_phone_number_placeholder"])}
                            onChange={this.handlePhoneNumberChange}
                            isValidForm={this.props.isValidForm}
                            checkValidForm={this.props.checkValidForm || false}
                            message={<FormattedMessage
                                id="customer.modal.add_form.contactMobilePhoneNumber_field_error"
                                defaultMessage="Please ensure the primary phone number is filled out properly"
                            />}
                        />
                    </div>
                </div>
                <AddressFormFields
                    value={this.state.address}
                    onChange={this.handleAddressChange} />
            </>
        )
    }
}

export default injectIntl(CompanyInputs);






// WEBPACK FOOTER //
// ./src/customer/companyInputs.component.jsx